import { createColor } from '@manakin/theme/lib/color';

const red = createColor('#CD171A');

export default red;
